var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgValidateFilled = function SvgValidateFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C0 3.6 3.6 0 8 0C12.4 0 16 3.6 16 8C16 12.4 12.4 16 8 16C3.6 16 0 12.4 0 8ZM7 8.8L10.3 5.3C10.7 4.9 11.3 4.9 11.7 5.2C12.1 5.6 12.1 6.25 11.7 6.65L8.05 10.5C7.8 10.8 7.4 10.95 7 10.95C6.6 10.95 6.25 10.8 5.95 10.55L4.3 8.7C3.9 8.3 3.9 7.7 4.3 7.3C4.7 6.9 5.3 6.9 5.7 7.3L7 8.8Z"
  })));
};
export default SvgValidateFilled;